export function BMap() {
	return new Promise(function (resolve, reject) {
		window.initialize = function () {
			resolve(BMap);

			/*window.BMap = window.BMapGL;
			var script = document.createElement("script");
			script.type = "text/javascript";
			script.src = "//api.map.baidu.com/library/MarkerClusterer/1.2/src/MarkerClusterer_min.js";
			script.onerror = reject;
			document.head.appendChild(script);

			var script = document.createElement("script");
			script.type = "text/javascript";
			script.src = "//api.map.baidu.com/library/TextIconOverlay/1.2/src/TextIconOverlay_min.js";
			script.onerror = reject;
			document.head.appendChild(script);*/
		}
		var script = document.createElement("script");
		script.type = "text/javascript";
		script.src = "//api.map.baidu.com/api?v=3.0&type=webgl&ak=iX2aOVwvoX2DOXelKLZwK1uIs4VHichr&callback=initialize";
		script.onerror = reject;
		document.head.appendChild(script);
	})
}


// WEBPACK FOOTER //
// ./src/config/BMap.js